import React, { useCallback, useEffect, useState } from 'react';

import get from 'lodash/get';

import {
  Grid,
  TextField,
  ConfirmDialog,
  Typography,
  makeStyles,
} from '@gogame/components';
import { DateRangeFormatter } from '@gogame/intl-ts';

import { useLoadIoDetails } from '../../data';

const useStyles = makeStyles((theme) => ({
  note: {
    margin: '0 20px',
    fontSize: 12,
    color: theme.palette.grey[700],
  },
}));
const ConfirmResendIODialog = ({ onSubmit, onExited, onClose, open, io }) => {
  const classes = useStyles();
  const { data } = useLoadIoDetails({ id: io.id });

  const [email, setEmail] = useState(data?.publisher?.legalContact?.email);

  useEffect(() => {
    setEmail(data?.publisher?.legalContact?.email);
  }, [data]);

  const handleChange = useCallback(
    (_e, value) => {
      setEmail(value);
    },
    [setEmail]
  );

  const handleSubmit = useCallback(() => {
    onSubmit({ email, userId: io.id });
  }, [onSubmit, email, io.id]);

  return (
    <ConfirmDialog
      title={'Re-send IO?'}
      confirmActionLabel={'Re-send'}
      onSubmit={handleSubmit}
      onExited={onExited}
      onClose={onClose}
      open={open}
      io={io}
    >
      <Grid container direction={'column'} spacing={2} gutter={'0 24px'}>
        <Grid item>
          <Typography varian={'subtitle1'}>
            {`${io?.businessPartner?.name}/ `}
            <DateRangeFormatter
              value={io?.period}
              template={'MONTH'}
              timeZone={'utc'}
            />
            &nbsp;
            {get(io, 'createdBy.name', io?.createdBy)}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            value={email}
            onChange={handleChange}
            label={'Email'}
            required={true}
            multiline={true}
            fullWidth
            rows={2}
          />
        </Grid>
        <Typography className={classes.note}>
          Will update BP’s contact email if changed
        </Typography>
      </Grid>
    </ConfirmDialog>
  );
};

export default ConfirmResendIODialog;
